import { useFilterIncidentTypeContext } from "./filter-incident-type.context";

export function FilterIncidentType() {
  const { dateFilterElement, reportFilterElements, clearFiltersElement } =
    useFilterIncidentTypeContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {reportFilterElements}
      {clearFiltersElement}
    </div>
  );
}